//LIBRARIES
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import withMobileDialog from '@material-ui/core/withMobileDialog';

//COMPONENTS
import TenantDetailsForm from './TenantDetailsForm';
import DrawerHeader from 'components/ui/DrawerHeader';
import DrawerFooter from 'components/ui/DrawerFooter';
import DrawerBody from 'components/ui/DrawerBody';

//HELPERS
import { deepDiver } from 'helpers/utilities';
import { getTranslatedString } from 'helpers/i18n';

//ACTIONS
import { getApplication } from 'actions/landlordApplicationsActions';
import { openEditLease } from 'actions/LeaseDetailsActions';
import { getLeadByEmail } from 'actions/landlordLeadsActions';
import { getTenants } from 'actions/landlordTenantsActions';

const FORM_NAME = 'edit_tenant_form';

let TenantDrawer = withMobileDialog()(
  connect(
    state => ({
      showTenantAdditionalOccupant: state.userTypes.showTenantAdditionalOccupant,
      showTenantPetDetails: state.userTypes.showTenantPetDetails,
      collectLeadSinNumberDuringApplication:
        state.companyDetails.companyPreferences.collect_lead_sin_number_during_application,
      propertyTypes: state.userTypes.propertyTypes,
      minimumApplicantAge: state.companyDetails.companyPreferences.minimum_applicant_age,
      isUserAdmin: deepDiver(state, 'userTypes.admin'),
    }),
    {
      getApplication,
      openEditLease,
      getLeadByEmail,
      getTenants,
    }
  )(
    class TenantDrawer extends Component {
      state = {
        existingTenant: null,
        confirmationDialogOpen: false,
        newTenant: null,
        confirmedAction: false,
        disableSubmit: true,
      };

      submitForm = async formData => {
        this.setState({ disableSubmit: false });

        if (!this.state.confirmedAction) {
          const response = await this.props.getLeadByEmail(formData.email, {
            exclude_id: this.props.applicant.lead_id,
          });
          if (deepDiver(response, 'value.lead')) {
            this.setState({
              existingTenant: response.value.lead,
              newTenant: formData,
              disableSubmit: true,
            });
            return;
          } else {
            this.setState({ existingTenant: null, newTenant: null });
          }
        }

        let response;
        let confirmedSameResident = false;
        if (this.state.confirmedAction) {
          confirmedSameResident = true;
        }

        if (this.props.createOrUpdateTenant) {
          let leaseId = null;
          if (this.props.application) {
            leaseId =
              deepDiver(this.props.applicant, 'lease.id') || this.props.application.lease_id;
          } else {
            leaseId =
              deepDiver(this.props.applicant, 'lease.id') ||
              deepDiver(this.props.applicant, 'leases.0.id');
          }
          response = await this.props.createOrUpdateTenant(leaseId, this.props.applicant.id, {
            ...formData,
            confirmed_same_resident: confirmedSameResident,
          });
        } else if (this.props.createOrUpdateApplicant) {
          response = await this.props.createOrUpdateApplicant(
            this.props.application.id,
            this.props.applicant.id,
            { ...formData, confirmed_same_resident: confirmedSameResident }
          );
        }

        if (response) {
          this.props.getTenants();
          this.props.toggleTenantDrawer();
          if (this.props.callback) {
            await this.props.callback();
          }
          this.setState({ disableSubmit: true, confirmedAction: false });
        }
      };

      render() {
        const {
          applicantType,
          hideSalary,
          overrideHideApplicationDetails,
          applicant,
          showTenantAdditionalOccupant,
          showTenantPetDetails,
          minimumApplicantAge,
          collectLeadSinNumberDuringApplication,
          toggleTenantDrawer,
        } = this.props;

        return (
          <Fragment>
            <DrawerHeader
              onClose={() => {
                toggleTenantDrawer();
                this.setState({ existingTenant: null, newTenant: null });
              }}
              title={getTranslatedString('landlordPortal.tenantDeetails.editResident')}
              closeVerbiage={getTranslatedString('landlordPortal.applicantDialog.cancel')}
            />
            <DrawerBody>
              <TenantDetailsForm
                minimumApplicantAge={minimumApplicantAge}
                formName={FORM_NAME}
                onSubmit={this.submitForm}
                initialValues={applicant}
                applicantType={applicantType}
                hideSalary={hideSalary}
                hideApplicationDetails={!deepDiver(applicant, 'applied')}
                overrideHideApplicationDetails={overrideHideApplicationDetails}
                showTenantAdditionalOccupant={showTenantAdditionalOccupant}
                showTenantPetDetails={showTenantPetDetails}
                collectLeadSinNumberDuringApplication={collectLeadSinNumberDuringApplication}
                existingTenant={this.state.existingTenant}
                enableSubmit={() => this.setState({ disableSubmit: false })}
                isUserAdmin={this.props.isUserAdmin}
              />
            </DrawerBody>
            <DrawerFooter
              primaryActionFormName={FORM_NAME}
              primaryActionText={getTranslatedString('landlordPortal.applicantDialog.save')}
              primaryActionDisabled={this.state.disableSubmit}
            />
          </Fragment>
        );
      }
    }
  )
);

export default localize()(TenantDrawer);
